import { render, staticRenderFns } from "./RouteTabs.vue?vue&type=template&id=37951c76&"
import script from "./RouteTabs.vue?vue&type=script&lang=js&"
export * from "./RouteTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports